import { useApiClient } from './apiClient';

export const useUserApis = () => {

  const { get, post, putR, customDelete } = useApiClient();

  const fetchUsers = async () => {
    try {
      const data = await get('api/users');
      return data._embedded.users.map(user => ({
        ...user,
        id: user._links.self.href.split("/").pop()
      }));
    } catch (err) {
      console.error('Error fetching users:', err);
      return []; // Return empty array on error
    }
  };
  
  const fetchUsername = async (id) => {
    try {
      const data = await get(`api/users/${id}`);
      return data.username;
    } catch (err) {
      console.error('Error fetching user data:', err);
      return null;
    }
  };
  
  const deleteUser = async (id) => {
    try {
      return await customDelete(`api/users/${id}`);
    } catch (err) {
      console.error('Error deleting user:', err);
      return false;
    }
  };
  
  const addUser = async (user) => {
    try {
      return await post('api/users/add', user);
    } catch (err) {
      console.error('Error adding user:', err);
      return null;
    }
  };
  
  const updateUser = async (user, id) => {
    try {
      return await putR(`password-users/${id}`, user);
    } catch (err) {
      console.error('Error updating user:', err);
      return false;
    }
  };
  
  const updateProfile = async (user, id) => {
    try {
      return await putR(`password-users/profile/${id}`, user);
    } catch (err) {
      console.error('Error updating profile:', err);
      return false;
    }
  };

return {
    fetchUsers,
    fetchUsername,
    deleteUser,
    addUser,
    updateUser,
    updateProfile
  };
}